import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  id: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  border: PropTypes.bool,
  step: PropTypes.string,
};

const defaultProps = {
  id: '',
  required: false,
  onChange: null,
  type: 'text',
  value: '',
  className: '',
  border: false,
  step: '',
};

const TextInput = React.forwardRef(function TextInput(props, ref) {
  const { name, id, type, placeholder, onChange, required, value, className, step } = props;

  return (
    <input
      {...props}
      ref={ref}
      step={step}
      className={clsx(
        'appearance-none block w-full py-1.5 px-2 text-gray-800 rounded border-none shadow-input focus:shadow-input-focus',
        className,
      )}
      name={name}
      id={id}
      type={type}
      placeholder={placeholder}
      onChange={onChange ? e => onChange(e) : null}
      required={required}
      value={value}
    />
  );
});

TextInput.propTypes = propTypes;
TextInput.defaultProps = defaultProps;

export default TextInput;
